import { updateLazy } from "Functions/lazy";
import { initTippy, initTippyDropdown } from "Functions/tippy";
import { initDatepickers } from "Functions/datepicker";

import "Layouts/default";

document.addEventListener("DOMContentLoaded", () => {
    initDatepickers();
});

import "./account-edit";
import "./account-claims";
import "./account-wishlists";

import "Ui/toggle";
import "Ui/horizontal-scroll";

initTippy();
initTippyDropdown();

Listing.customCallbacks.beforeFetch = () => {
    rEvent.dispatch("Listing.customBeforeFetch");
};

rEvent.on("Listing.customBeforeFetch", function () {
    if ($(".listing__holder").length) {
        $(".listing__holder").addClass("is-loading");
    }
    if ($(".c-msg.is-empty.listing").length) {
        $(".c-msg.is-empty.listing").addClass("is-loading");
    }
});

rEvent.on("Listing.fetchedData", function (data) {
    requestAnimationFrame(() => {
        if ($(".listing__holder").length) {
            $(".listing__holder").removeClass("is-loading");
        }

        if ($(".pager__load").length) {
            $(".pager__load").removeClass("is-loading");
        }
    });

    initTippy();
    initTippyDropdown();
    updateLazy();
});

let printTriggers = document.querySelectorAll(".js-trigger-print");

if (printTriggers) {
    printTriggers.forEach((trigger) => {
        trigger.addEventListener("click", (e) => {
            e.preventDefault();
            window.print();
        });
    });
}
